import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Stack,
  Button,
  TextField,
  Select,
  MenuItem,
  Typography,
  Divider,
  IconButton,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';

export function ModalGastos({
  open,
  onClose,
  fechaSeleccionada = null,
  state,
  gastosState,
  categorias = [],
  díaBloqueado = false,
  subirFuturo = null,
  editando = false,
  gastoEditando = null,
  onRegistrar = null
}) {
  const [metodoPago, setMetodoPago] = useState('EFECTIVO');
  const [filaActual, setFilaActual] = useState({
    categoriaId: '',
    monto: '',
    descripcion: ''
  });
  const [carrito, setCarrito] = useState([]);

  const agregarAlCarrito = () => {
    if (!filaActual.categoriaId || !filaActual.monto) {
      alert('Completa categoría y monto');
      return;
    }

    const categoria = categorias.find(c => c.id === filaActual.categoriaId);
    const monto = parseFloat(filaActual.monto);

    setCarrito(prev => [
      ...prev,
      {
        categoriaId: filaActual.categoriaId,
        nombreCategoria: categoria?.nombre || 'Sin categoría',
        monto,
        descripcion: filaActual.descripcion,
        metodoPago
      }
    ]);

    setFilaActual({ categoriaId: '', monto: '', descripcion: '' });
  };

  const eliminarDelCarrito = (index) => {
    setCarrito(prev => prev.filter((_, i) => i !== index));
  };

  const handleGuardarTodo = async () => {
    if (carrito.length === 0) {
      alert('Agrega al menos un gasto');
      return;
    }

    if (díaBloqueado) {
      alert('⛔ No puedes registrar gastos cuando hay un arqueo completado en el día');
      return;
    }

    for (const item of carrito) {
      await gastosState.registrarGasto(item.monto, item.categoriaId, item.descripcion, item.metodoPago, fechaSeleccionada);
    }
    alert(`${carrito.length} gasto(s) registrado(s)`);
    setCarrito([]);
    setFilaActual({ categoriaId: '', monto: '', descripcion: '' });
    onClose();
    onRegistrar?.([...carrito]);
  };

  const guardarEdicion = async () => {
    if (!filaActual.monto) {
      alert('Monto inválido');
      return;
    }

    if (onRegistrar) {
      onRegistrar({
        ...gastoEditando,
        monto: parseFloat(filaActual.monto),
        descripcion: filaActual.descripcion
      });
    }

    onClose();
  };

  const total = carrito.reduce((sum, item) => sum + item.monto, 0);

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
        {editando ? 'Editar gasto' : 'Registrar gastos'}
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Stack direction="column" spacing={2}>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Método de pago:</Typography>
            <ToggleButtonGroup
              value={metodoPago}
              exclusive
              onChange={(e, newMetodo) => { if (newMetodo !== null) setMetodoPago(newMetodo); }}
              fullWidth
            >
              <ToggleButton value="EFECTIVO">Efectivo</ToggleButton>
              <ToggleButton value="QR">QR</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Stack direction="row" spacing={1}>
            <Select
              fullWidth
              value={filaActual.categoriaId}
              onChange={e => setFilaActual({ ...filaActual, categoriaId: e.target.value })}
            >
              <MenuItem value="" disabled>Categoría</MenuItem>
              {categorias.map(c => (
                <MenuItem key={c.id} value={c.id}>{c.nombre}</MenuItem>
              ))}
            </Select>

            <TextField
              label="Monto"
              type="number"
              value={filaActual.monto}
              onChange={e => setFilaActual({ ...filaActual, monto: e.target.value })}
              inputProps={{ step: '0.01' }}
            />

            <TextField
              label="Descripción"
              value={filaActual.descripcion}
              onChange={e => setFilaActual({ ...filaActual, descripcion: e.target.value })}
            />

            {!editando && (
              <Button variant="contained" onClick={agregarAlCarrito} sx={{ minWidth: 50 }}>
                <AddCircleIcon />
              </Button>
            )}
          </Stack>
        </Stack>

        {!editando && (
          <>
            <Divider sx={{ mt: 3 }} />
            <Box sx={{ maxHeight: 300, overflow: 'auto', mt: 2 }}>
              {carrito.map((item, i) => (
                <Stack
                  key={i}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  p={1}
                  sx={{ bgcolor: '#f5f5f5', mb: 1, borderRadius: 1 }}
                >
                  <Typography variant="body2">
                    {item.nombreCategoria} - {item.monto.toFixed(2)}
                    {item.descripcion && ` (${item.descripcion})`}
                  </Typography>
                  <IconButton color="error" size="small" onClick={() => eliminarDelCarrito(i)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ))}
            </Box>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ flexDirection: 'column', gap: 2, p: 2 }}>
        {!editando && (
          <Box sx={{ width: '100%', textAlign: 'right' }}>
            <Typography variant="h6" fontWeight="bold">
              Total: {total.toFixed(2)}
            </Typography>
          </Box>
        )}

        {editando ? (
          <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
            <Button fullWidth variant="outlined" onClick={onClose}>Cancelar</Button>
            <Button fullWidth variant="contained" onClick={guardarEdicion}>Guardar cambios</Button>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
            <Button fullWidth variant="outlined" onClick={onClose}>Cancelar</Button>
            <Button
              fullWidth
              variant="contained"
              disabled={!carrito.length || díaBloqueado}
              onClick={handleGuardarTodo}
            >
              Confirmar
            </Button>
          </Stack>
        )}
      </DialogActions>
    </Dialog>
  );
}
